import { motion } from "framer-motion";
import logoFull from "@/assets/orbit-logo.png";
import logoWordmark from "@/assets/orbit-wordmark.png";
import logoFullOffice from "@/assets/orbit-logo-office.png";
import logoWordmarkOffice from "@/assets/orbit-wordmark-office.png";

export function Logo({ size = "md", variant = "default", light = false }) {
  const isLg = size === "lg";
  const office = variant === "office";
  const src = isLg
    ? (office ? logoFullOffice : logoFull)
    : (office ? logoWordmarkOffice : logoWordmark);
  const heightCls = isLg ? "h-16" : "h-10";
  return (
    <div className="flex items-center" data-testid="orbit-logo">
      <img
        src={src}
        alt="Orbit — Digital Ecosystem"
        draggable="false"
        className={`${heightCls} w-auto max-w-full object-contain select-none ${light ? "brightness-0 invert" : ""}`}
      />
    </div>
  );
}

export function AuthShell({ children }) {
  return (
    <div className="worker-theme min-h-screen w-full flex items-center justify-center p-4 relative overflow-hidden bg-[#F8FAFC]">
      <div
        className="absolute inset-0 opacity-[0.9]"
        style={{
          backgroundImage:
            "radial-gradient(circle at 15% 20%, rgba(34,54,77,0.08), transparent 40%), radial-gradient(circle at 85% 80%, rgba(85,122,149,0.12), transparent 45%)",
        }}
      />
      <motion.div
        initial={{ opacity: 0, y: 12 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4, ease: "easeOut" }}
        className="relative w-full max-w-md"
      >
        {children}
      </motion.div>
    </div>
  );
}
